import { categories } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          {/* brand */}
          <div>
            <a href="#hero" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-xl">
                <i className="ri-restaurant-line"></i>
              </span>
              <span className="font-display text-2xl">色瓜网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/75">
              色瓜网是一档面向年轻网民的娱乐热点速递站，以「今日吃瓜」的方式，为你每天滚动整理明星动态、网红生态、综艺热梗与社会趣闻，陪你看清每一场热闹。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#hero" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/25">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" aria-label="微信公众号" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/25">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" aria-label="视频号" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/25">
                <i className="ri-vidicon-line"></i>
              </a>
              <a href="#hero" aria-label="知乎" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/25">
                <i className="ri-zhihu-line"></i>
              </a>
            </div>
          </div>

          {/* columns */}
          <div>
            <h4 className="font-display text-lg text-secondary-200">内容栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories
                .filter((c) => c.key !== "全部")
                .map((c) => (
                  <li key={c.key}>
                    <a href="#feed" className="text-background-50/75 transition-colors hover:text-background-50">
                      {c.label}
                    </a>
                  </li>
                ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-secondary-200">快速直达</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                { href: "#hero", label: "今日热搜" },
                { href: "#feed", label: "热点速递" },
                { href: "#deep", label: "深度盘点" },
                { href: "#trend", label: "吃瓜排行" },
                { href: "#faq", label: "常见问答" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-background-50/75 transition-colors hover:text-background-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* principles / contact */}
          <div>
            <h4 className="font-display text-lg text-secondary-200">内容原则</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75">
              我们坚持客观整理、理性讨论，不造谣、不传谣，尊重每一位内容创作者。欢迎通过邮箱与我们交流。
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-background-50/75">
              <i className="ri-mail-line text-secondary-200"></i>
              <a href="mailto:hello@seguawa.com" className="transition-colors hover:text-background-50">
                hello@seguawa.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-50/60">© {new Date().getFullYear()} 色瓜网 · 今天也要开心吃瓜</p>
          <p className="text-xs text-background-50/60">热点数据仅供参考 · 理性围观，友善发言</p>
        </div>
      </div>
    </footer>
  );
}